import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="14" height="19" viewBox="0 0 14 19" fill="none" {...props}><path d="M7 .88a2.81 2.81 0 012.81 2.8v5.63a2.81 2.81 0 11-5.62 0V3.7A2.81 2.81 0 017 .88zm6.56 8.43c0 3.31-2.44 6.04-5.62 6.5v2.88H6.06V15.8A6.57 6.57 0 01.44 9.3H2.3a4.69 4.69 0 009.38 0h1.87z" fill="#fff" /></svg>);